import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, align = "left" }) => (
    <Reveal className={align === "center" ? "text-center" : ""}>
        <p className="eyebrow mb-4">{eyebrow}</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-3xl leading-tight">
            {title}
        </h2>
        {sub && <p className="mt-4 text-base text-slate-400 max-w-2xl leading-relaxed">{sub}</p>}
    </Reveal>
);
